import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@chakra-ui/react';
import Slider from '../Slider/Slider';
import ManagementWarning from '../ManagementWarning';
import EditBadgeMachineTypeTab from './EditBadgeMachineTypeTab';
import { useDocumentTitle } from '../../../utils/useDocumentTitle';

function BadgeMachineTypeWarningTab({ user, labId, pushTab, revert, index }) {
  useDocumentTitle('Admin: Before managing badge requirements – Pinpoint');
  return <Slider name="Before managing badge requirements" slide index={index} onClick={() => revert(1)}>
    <ManagementWarning title="Changes can affect access across spaces" onCancel={() => revert(1)}
      onContinue={() => pushTab(<EditBadgeMachineTypeTab adminRoute="badges" key={`EditBadgeMachineTypeTab-${labId}`}
        user={user} labId={labId} pushTab={pushTab} revert={revert} />)}>
      Badge requirements are shared across all spaces. Changing a tool’s badge requirements can change who can use its instances in spaces with badge integration enabled.
        <br /><br />
        <Link href="https://docs.pinpoint.umd.edu/docs/guides/makerspaces/parchment-badges/machine-type-badge" color="blue.600" textDecoration="underline">Review the badge requirements guide</Link> before making changes.
    </ManagementWarning>
  </Slider>;
}

BadgeMachineTypeWarningTab.propTypes = {
  user: PropTypes.object.isRequired,
  labId: PropTypes.string.isRequired,
  pushTab: PropTypes.func.isRequired,
  revert: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
export default BadgeMachineTypeWarningTab;
